<template>
	<div class="tool-ai">
		<h1>智能化研发管理工具</h1>
		<section class="title-button">
			<div class="btn-box">
				<div class="free-btn">
					<button
						class="button"
						@click="onClickLogin"
					>
						免费注册
					</button>
				</div>
				<div class="pre-button">
					<button
						class="pre-button"
						@click="onClickPlay"
					>
						预约演示
					</button>
				</div>
			</div>
		</section>
		<div class="tools-box">
			<img
				src="https://static.bimcc.com/openim/%E9%A6%96%E9%A1%B5-%E5%86%85%E5%AE%B97-%E6%99%BA%E8%83%BD%E5%8C%96%E7%A0%94%E5%8F%91%E7%AE%A1%E7%90%86%E5%B7%A5%E5%85%B78DDD38E0CCDA10E909686C5CBFA6D776.png"
				class="item-img"
			/>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ManagementTool',
	components: {},
	data() {
		return {};
	},
	methods: {
		onClickPlay() {
			this.$router.push({ name: 'ApplyDemo' });
		},
		onClickLogin() {
			window.location.href = `https://saas.bimcc.com/login?index=1`;
		}
	}
};
</script>

<style lang="less" scoped>
.tool-ai {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	width: 1200px;
	padding-bottom: 122px;
	box-sizing: border-box;
	text-align: center;
	h1 {
		padding: 82px 0 70px 0;
		box-sizing: border-box;
		color: #4a4a4a;
		font-family: 'Source Han Sans CN';
		font-style: normal;
		font-weight: 700;
		font-size: 42px;
		line-height: 63px;
		white-space: nowrap;
	}
	.title-button {
		flex: 1;
		display: flex;
		justify-content: center;
		padding-bottom: 46px;
		box-sizing: border-box;
		.btn-box {
			display: flex;
			justify-content: space-between;
			width: 277px;
			.free-btn {
				.button {
					width: 125px;
					height: 50px;
					background: #337eff;
					border: 1px solid #337eff;
					color: #ffffff;
					font-family: 'Source Han Sans CN';
					font-style: normal;
					font-weight: 400;
					font-size: 16px;
					line-height: 24px;
					border-radius: 7px;
				}
				.button:hover {
					transform: scale(1.1);
				}
			}
			.pre-button {
				.pre-button {
					width: 125px;
					height: 50px;
					border: 1px solid #337eff;
					color: #4a4a4a;
					font-family: 'Source Han Sans CN';
					font-style: normal;
					font-weight: 400;
					font-size: 16px;
					line-height: 24px;
					border-radius: 7px;
				}
				.pre-button:hover {
					box-shadow: 0 2px 12px 0 rgb(0 0 0 / 40%);
					transform: scale(1.1);
				}
			}
		}
	}
	.tools-box {
		width: 100%;
		.item-img {
			width: 100%;
		}
	}
	.list-box {
		display: flex;
		justify-content: space-between;
		width: 100%;
		height: 100%;
		padding: 46px 0 29.84px 0;
		box-sizing: border-box;
		.item {
			position: relative;
			width: 22%;
			height: 165.71px;
			.item-img {
				width: 100%;
			}
		}
	}
}
</style>
